import axios from "axios";
import { ProfesionalPerfil } from "../models/profesional-perfil";

export const PROFESIONAL_URL = `Profesional`;

export const profesionalServices = {
  lookup: (queryParams: any) => {
    return axios.get<any>(`${PROFESIONAL_URL}/Lookup`, {
      params: { ...queryParams },
    });
  },

  activos: () => {
    return axios.get<any>(`${PROFESIONAL_URL}/Activos`);
  },

  getPerfil: (id: string) => {
    return axios.get<ProfesionalPerfil>(`${PROFESIONAL_URL}/${id}/Perfil`);
  },

  updatePerfil: (
    id: string,
    data: Omit<
      ProfesionalPerfil,
      "id" | "nombre" | "apellido" | "matriculaProf"
    >
  ) => {
    return axios.put(`${PROFESIONAL_URL}/${id}/Perfil`, data);
  },
};
